angular.module('vehicle-issue')
    .factory('VehicleIssue', function ($resource) {
        return $resource('crm/api/vehicle/:id/issue', {id: '@id'}, {
            table: {method: 'GET', url: 'crm/api/vehicle/:id/issue/table', isArray: false},
            toggle: {method: 'PUT', url: 'crm/api/vehicle/:id/issue/:issueId/toggle', params: {id: '@id', issueId: '@issueId'}},
            bookingIssues: {method: 'GET', url: 'crm/api/vehicle-booking/:id/issue', isArray: true},
            delete: {method: 'DELETE', url: 'crm/api/vehicle/:id/issue/:issueId', params: {id: '@id', issueId: '@issueId'}}
        })
    })
